import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=95875bb4&scoped=true&lang=pug"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95875bb4",
  null
  
)

export default component.exports